<template>
  <div>
    <Modal
      v-model="modal"
      :title="$t('PB_Select_Employee_Search')"
      width="95%"
      fullscreen
      :closable="false"
      :mask-closable="false"
      ><!-- 选择员工 -->
      <Form :model="modalFormItem" :label-width="100" label-position="left">
        <Row :gutter="20">
          <Col :xs="24" :sm="24" :md="12" :lg="6">
            <FormItem :label="$t('BU')"
              ><!-- 业务单元 -->
              <Select
                v-model="modalFormItem.businessUnit"
                clearable
                style="width: 100%"
              >
                <Option
                  v-for="item in businessUnitList"
                  :value="item.ch_value"
                  :key="item.code"
                  >{{ lang == "zh" ? item.ch_value : item.en_value }}</Option
                >
              </Select>
            </FormItem>
          </Col>
          <Col :xs="24" :sm="24" :md="12" :lg="6">
            <FormItem :label="$t('Department')"
              ><!-- 大区 -->
              <Select
                v-model="modalFormItem.department"
                clearable
                style="width: 100%"
              >
                <Option
                  v-for="item in departmentList"
                  :value="item.ch_value"
                  :key="item.code"
                  >{{ lang == "zh" ? item.ch_value : item.en_value }}</Option
                >
              </Select>
            </FormItem>
          </Col>
          <Col :xs="24" :sm="24" :md="12" :lg="6">
            <FormItem :label="$t('Funciton')"
              ><!-- 职能 -->
              <Select
                v-model="modalFormItem.postFun"
                clearable
                style="width: 100%"
              >
                <Option
                  v-for="item in functionList"
                  :value="item.ch_value"
                  :key="item.code"
                  >{{ lang == "zh" ? item.ch_value : item.en_value }}</Option
                >
              </Select>
            </FormItem>
          </Col>
          <Col :xs="24" :sm="24" :md="12" :lg="6">
            <FormItem :label="$t('Management_Level')"
              ><!-- 管理层级 -->
              <Select
                v-model="modalFormItem.hrmanage"
                clearable
                style="width: 100%"
              >
                <Option
                  v-for="item in ManagementLevel"
                  :value="item.ch_value"
                  :key="item.code"
                  >{{ lang == "zh" ? item.ch_value : item.en_value }}</Option
                >
              </Select>
            </FormItem>
          </Col>
          <Col :xs="24" :sm="24" :md="12" :lg="6">
            <FormItem :label="this.$t('DepartmentSalesRegion')"
              ><!-- 部门/销售区域 -->
              <Select v-model="modalFormItem.salesArea" clearable>
                <Option
                  v-for="item in salesAreaList"
                  :value="item.code"
                  :key="item.code"
                  >{{ lang == "zh" ? item.ch_value : item.en_value }}</Option
                >
              </Select>
            </FormItem>
          </Col>
          <Col :xs="24" :sm="24" :md="12" :lg="6">
            <FormItem :label="$t('Position')"
              ><!-- 职位 -->
              <Input v-model="modalFormItem.position" />
            </FormItem>
          </Col>
          <Col :xs="24" :sm="24" :md="12" :lg="6">
            <FormItem :label="$t('Employee_Code')"
              ><!-- 员工号 -->
              <Input type="text" v-model="modalFormItem.empCode" />
            </FormItem>
          </Col>
          <Col :xs="24" :sm="24" :md="12" :lg="6">
            <FormItem :label="$t('Name')"
              ><!-- 姓名 -->
              <Input type="text" v-model="modalFormItem.userName" />
            </FormItem>
          </Col>
          <Col :xs="24" :sm="24" :md="12" :lg="6">
            <FormItem :label="$t('English_Name')"
              ><!-- 英文名 -->
              <Input type="text" v-model="modalFormItem.eName" />
            </FormItem>
          </Col>
          <Col :xs="24" :sm="24" :md="12" :lg="6">
            <FormItem :label="$t('Line_Manager')"
              ><!-- 直接上级 -->
              <Input
                type="text"
                v-model="modalFormItem.dirSupName"
                search
                enter-button
                clearable
                readonly
                @on-clear="dirClear()"
                @on-search="dirSearch"
              />
            </FormItem>
            <p
              style="
                font-size: 12px;
                color: red;
                margin-top: -15px;
                margin-bottom: 10px;
              "
            >
              {{ $t("PB_longText31")
              }}<!-- *默认显示选择人员的所有下属，如需进一步筛选，请选择汇报层级 -->
            </p>
          </Col>
          <Col :xs="24" :sm="24" :md="12" :lg="6">
            <FormItem :label="$t('Reporting_Line')"
              ><!-- 汇报层级 -->
              <Select
                v-model="modalFormItem.levelNum"
                multiple
                clearable
                :disabled="levelDisabledState"
              >
                <Option
                  v-for="item in Level"
                  :value="item.code"
                  :key="item.code"
                  >{{ lang == "zh" ? item.ch_value : item.en_value }}</Option
                >
              </Select>
            </FormItem>
          </Col>
          <Col :xs="24" :sm="24" :md="12" :lg="6">
            <FormItem :label="$t('Carlsberg_Band')"
              ><!-- 嘉士伯级别 -->
              <Select
                v-model="modalFormItem.hcmBand"
                clearable
                style="width: 100%"
              >
                <Option
                  v-for="item in Band"
                  :value="item.ch_value"
                  :key="item.code"
                  >{{ lang == "zh" ? item.ch_value : item.en_value }}</Option
                >
              </Select>
            </FormItem>
          </Col>
          <Col :xs="24" :sm="24" :md="12" :lg="6">
            <FormItem :label="$t('IsNotSTIEmp')"
              ><!-- 是否有STI -->
              <Select v-model="modalFormItem.perresult" clearable>
                <Option
                  v-for="item in YesOrNo"
                  :value="item.code"
                  :key="item.code"
                  >{{ lang == "zh" ? item.ch_value : item.en_value }}</Option
                >
              </Select>
            </FormItem>
          </Col>
          <Col
            :xs="24"
            :sm="24"
            :md="12"
            :lg="6"
            v-if="targetkey == 'assessedList' || targetkey == 'successorList'"
          >
            <FormItem :label="$t('PB_Employment_Status')"
              ><!-- 在职状态 -->
              <Select
                v-model="modalFormItem.beQuit"
                clearable
                style="width: 100%"
              >
                <Option
                  v-for="item in BeQuit"
                  :value="item.code"
                  :key="item.code"
                  >{{ lang == "zh" ? item.ch_value : item.en_value }}</Option
                >
              </Select>
            </FormItem>
          </Col>
          <Col :xs="24" :sm="24" :md="12" :lg="6">
            <FormItem :label="$t('PersonelType2')"
              ><!-- personneltype2 -->
              <Select v-model="modalFormItem.personnelType" clearable>
                <Option
                  v-for="item in personnelType"
                  :value="item.code"
                  :key="item.code"
                  >{{ lang == "zh" ? item.ch_value : item.en_value }}</Option
                >
              </Select>
            </FormItem>
          </Col>
          <Col :xs="24" :sm="24" :md="12" :lg="6">
            <FormItem :label="this.$t('GroupSelect')">
              <UserGroupList
                ref="UserGroupList"
                @confirmSelectGroup="confirmSelectGroup"
              ></UserGroupList>
            </FormItem>
          </Col>
          <Col :xs="24" :sm="24" :md="12" :lg="4">
            <Button @click="(pageInfo.pageNo = 1), getData()"
              ><!-- 检 索 -->{{ $t("Search") }}</Button
            >
            <Button @click="handleReset()"
              ><!-- 清空检索 -->{{ $t("PB_Clear") }}</Button
            >
          </Col>
        </Row>
      </Form>

      <Table
        highlight-row
        border
        :columns="modelColumns"
        :data="modelData"
        @on-select-cancel="TableSelectCancelRow"
        @on-select-all-cancel="cancelAll"
        @on-select-all="selsetAll"
        @on-select="peoOnSelectRow"
        @on-selection-change="itemChange"
        ref="selectiona"
        :loading="loading"
        :max-height="tableheight"
        style="margin-top: 20px"
      ></Table>

      <div style="display: flex; justify-content: end; margin-top: 30px">
        <Page
          :total="total"
          :current="pageInfo.pageNo"
          :page-size="pageInfo.pageSize"
          transfer
          :page-size-opts="[10, 50, 100, 150]"
          show-sizer
          @on-page-size-change="pageSizeChange"
          @on-change="pageChange"
        ></Page>
      </div>

      <div slot="footer">
        <Button type="text" @click="handleConfirm" :disabled="loading"
          ><!-- 确认 -->{{ $t("Confirm") }}</Button
        >
        <Button type="text" @click="handleCancle" :disabled="loading"
          ><!-- 取消 -->{{ $t("Cancel") }}</Button
        >
      </div>
    </Modal>
    <JobModal ref="JobModal" @jobSave="jobSave"></JobModal>
    <DirModalComponent
      ref="DirModalComponent"
      @selectRow="dirSelect"
    ></DirModalComponent>
  </div>
</template>

<script>
import axios from "axios";
import EventBus from "@/util/eventBus.js";
import JobModal from "./JobModal";
import DirModalComponent from "../components/modalComponents/DirModalComponent.vue";
import UserGroupList from "../components/UserGroupList.vue";
export default {
  components: { JobModal, DirModalComponent, UserGroupList },
  data() {
    return {
      loading: false,
      modal: false,
      modalFormItem: {
        dirSupName: "",
        levelNum: [],
      },

      modelData: [],
      pageInfo: {
        itemCount: 0,
        pageNo: 1,
        pageSize: 10,
      },
      total: 0,
      list: [],
      positionList: [],
      ApplyStatus: [],
      departmentList: [],
      functionList: [],
      BeQuit: [],
      YesOrNo: [],
      salesAreaList: [],
      businessUnitList: [],
      Level: [],
      ManagementLevel: [],
      BeQuit: [],
      selectList: [],
      Band: [],
      state: false,
      rowItem: {},
      targetkey: "",
      userType: "",
      id: "",
      nullJobNum: 0,
      btnShow: false,
      beEnd: "",
      personNum: 0,
      levelDisabledState: true,
      searchState: false,
      tableheight: 560,
      personnelType: [],
    };
  },
  computed: {
    modelColumns() {
      return [
        {
          type: "selection",
          minWidth: 60,
          align: "center",
        },
        {
          title: this.$t("Employee_Code") /* 员工号 */,
          key: "empCode",
          align: "center",
          minWidth: 200,
        },
        {
          title: this.$t("Name") /* 姓名 */,
          key: "userName",
          align: "center",
          minWidth: 200,
        },
        {
          title: this.$t("English_Name") /* 英文名 */,
          key: "userEName",
          align: "center",
          minWidth: 200,
        },
        {
          title: this.$t("BU") /* 业务单元 */,
          key: this.lang == "zh" ? "businessUnit" : "enBusinessUnit",
          align: "center",
          minWidth: 200,
        },
        {
          title: this.$t("Department") /* 大区 */,
          key: this.lang == "zh" ? "department" : "enDepartment",
          align: "center",
          minWidth: 200,
        },
        {
          title: this.$t("Funciton") /* 职能 */,
          key: this.lang == "zh" ? "postFun" : "enPostFun",
          align: "center",
          minWidth: 200,
        },
        {
          title: this.$t("Position_Name_Chinese") /* 职位名称（中文） */,
          key: "positionCTitle",
          align: "center",
          minWidth: 200,
        },
        {
          title: this.$t("Position_Name_English") /* 职位名称（英文） */,
          key: "positionETitle",
          align: "center",
          minWidth: 200,
        },
        {
          title: this.$t("Line_Manager") /* 直线上级 */,
          key: "dirSupName",
          align: "center",
          minWidth: 200,
        },
        {
          title: this.$t("Hire_Date") /* 入职日期 */,
          key: "hireDate",
          align: "center",
          minWidth: 160,
        },
        {
          title: this.$t("PB_Resign_Date") /* 离职日期 */,
          key: "quitDate",
          align: "center",
          minWidth: 160,
        },
      ];
    },
    lang() {
      return this.$store.getters.selectLangeData;
    },
  },
  created() {
    // this.getData()
    this.getListData();
  },
  mounted() {
    window.onresize = () => {
      return (() => {
        this.tableheight = window.innerHeight - 300;
      })();
    };
  },
  watch: {
    selectList: {
      handler(newVal, oldVal) {
        newVal.forEach((res) => {
          this.modelData.forEach((el, index) => {
            el._checked = false;
            if (el.empCode === res.empCode) {
              this.$refs.selectiona.objData[index]._isChecked = true;
            }
          });
        });
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    confirmSelectGroup(list) {
      this.modalFormItem.userGroupList = JSON.parse(JSON.stringify(list));
    },
    getListData() {
      axios.post("/achReport/selectAchReportLabelInfo", {}).then((res) => {
        if (res) {
          this.positionList = res.positionList;
          this.departmentList = res.departmentList;
          this.businessUnitList = res.businessUnitList;
          this.Level = res.Level;
          this.Band = res.Band;
          this.salesAreaList = res.salesAreaList;
          this.YesOrNo = res.YesOrNo;
          this.BeQuit = res.BeQuit;
          this.functionList = res.functionList;
          this.BeQuit = res.BeQuit;
          this.ManagementLevel = res.ManagementLevel;
          this.personnelType = res.personnelType;
        }
      });
    },
    getIsData() {
      let obj = {
        userType: this.userType,
        id: this.id,
        ...this.modalFormItem,
        ...this.pageInfo,
      };
      this.loading = true;
      axios
        .post("/TalentInventory/selectPeoPleBoardPerson", obj)
        .then((res) => {
          this.loading = false;
          if (res) {
            this.modelData = res.data;
            this.modelData.forEach((el) => {
              el._disabled = false;
              if (this.beEnd == 1) {
                el._disabled = true;
              }
            });
            if (this.selectList.length > 0) {
              this.$nextTick(() => {
                this.selectList.forEach((res, i) => {
                  this.modelData.forEach((el, index) => {
                    el._checked = false;

                    if (el.empCode === res.empCode) {
                      this.$refs.selectiona.objData[index]._isChecked = true;
                    }
                  });
                });
              });
            }
            if (this.selectList.length > 0) {
              this.personNum = this.selectList.length;
            } else {
              this.personNum = res.personNum;
            }
            this.total = parseInt(res.pageInfo.total);
          }
        });
    },
    getData() {
      let obj = {
        userType: this.userType,
        id: this.id,
        ...this.modalFormItem,
        ...this.pageInfo,
      };
      this.loading = true;
      axios.post("/TalentInventory/selectUserList", obj).then((res) => {
        this.loading = false;
        if (res) {
          this.searchState = true;
          this.modelData = res.data;
          this.modelData.forEach((el) => {
            el._disabled = false;
            if (this.beEnd == 1) {
              el._disabled = true;
            }
          });
          if (this.selectList.length > 0) {
            this.$nextTick(() => {
              this.selectList.forEach((res) => {
                this.modelData.forEach((el, index) => {
                  el._checked = false;

                  if (el.empCode === res.empCode) {
                    this.$refs.selectiona.objData[index]._isChecked = true;
                  }
                });
              });
            });
          }
          if (this.selectList.length > 0) {
            this.personNum = this.selectList.length;
          } else {
            this.personNum = res.personNum;
          }
          this.total = parseInt(res.pageInfo.total);
        }
      });
    },
    targetItemChange(row, index, key) {
      key && this.$set(this.columnsData[index], key, row[`${key}`]);
    },

    pageChange(val) {
      this.pageInfo.pageNo = val;
      if (this.searchState) {
        this.getData();
      } else {
        this.getIsData();
      }
    },
    handleConfirm() {
      // this.modelColumns.splice(0, 1);

      if (this.state == true) {
        this.rowItem[`${this.targetkey}`] = this.selectList;
        let obj = JSON.parse(JSON.stringify(this.rowItem));
        obj.sendMailFlag ? (obj.sendMailFlag = "1") : (obj.sendMailFlag = "0");
        axios.post("/TalentInventory/saveTalentInventory", obj).then((res) => {
          if (res) {
            // EventBus.$emit('savePerson')
          }
        });
        this.modal = false;
      } else {
        this.rowItem[`${this.targetkey}`] = this.selectList;
        let json = JSON.parse(JSON.stringify(this.rowItem));
        json.sendMailFlag
          ? (json.sendMailFlag = "1")
          : (json.sendMailFlag = "0");
        // 被评估人 先check后保存
        if (this.userType == "1") {
          this.$emit("peoSave", JSON.parse(JSON.stringify(json)));
        } else {
          let obj = {
            id: this.id,
            userType: this.userType,
            peopleList: this.selectList,
            ...json,
          };
          this.loading = true;
          axios
            .post("/TalentInventory/saveTalentInventoryUser", obj)
            .then((res) => {
              this.loading = false;
              if (res != null && res.length > 0) {
                this.$emit("peoSave", JSON.parse(JSON.stringify(json)));
              } else {
                this.$emit(
                  "onSelectList",
                  JSON.parse(JSON.stringify(this.selectList))
                );
                // this.getData()
                this.modal = false;
                this.$Message.success(this.$t("Save_Successful"));
                this.$nextTick(() => {
                  this.$refs.selectiona.selectAll(false);
                  this.pageInfo.pageNo = 1;
                  this.searchState = false;
                  this.modalFormItem = {
                    dirSupName: "",
                    levelNum: [],
                  };
                });
              }
            });
        }

        // this.$emit('peoSave',JSON.parse(JSON.stringify(this.selectList)))
        // this.$emit('onSelectList',JSON.parse(JSON.stringify(this.selectList)))
      }
    },
    saveTwo() {
      this.rowItem[`${this.targetkey}`] = this.selectList;
      let json = JSON.parse(JSON.stringify(this.rowItem));
      json.sendMailFlag ? (json.sendMailFlag = "1") : (json.sendMailFlag = "0");
      // 被评估人 先check后保存
      let obj = {
        id: this.id,
        userType: this.userType,
        peopleList: this.selectList,
        ...json,
      };
      this.loading = true;
      axios
        .post("/TalentInventory/saveTalentInventoryUser", obj)
        .then((res) => {
          this.loading = false;
          if (res != null && res.length > 0) {
            this.$emit("peoSave", JSON.parse(JSON.stringify(json)));
          } else {
            this.$emit(
              "onSelectList",
              JSON.parse(JSON.stringify(this.selectList))
            );
            // this.getData()
            this.modal = false;
            this.$Message.success(this.$t("Save_Successful"));
            this.$nextTick(() => {
              this.$refs.selectiona.selectAll(false);
              this.pageInfo.pageNo = 1;
              this.searchState = false;
              this.modalFormItem = {
                dirSupName: "",
                levelNum: [],
              };
            });
          }
        });
    },
    handleCancle() {
      // this.modelColumns.splice(0, 1);
      this.modal = false;
      this.$nextTick(() => {
        this.$refs.selectiona.selectAll(false);
        this.pageInfo.pageNo = 1;
        this.searchState = false;
        this.modalFormItem = {
          dirSupName: "",
          levelNum: [],
        };
      });
    },
    TableSelectCancelRow(selection, row) {
      this.selectList.forEach((el, index) => {
        if (el.serialnumber == row.serialnumber) {
          this.selectList.splice(index, 1);
        }
      });
    },
    peoOnSelectRow(selection, row) {
      if (!this.selectList.includes(row.serialnumber)) {
        this.selectList.push(row);
      }
    },
    selsetAll(selection) {
      this.modelData.forEach((el) => {
        this.selectList.push(el);
      });
      let map = new Map();
      for (let item of this.selectList) {
        map.set(item.serialnumber, item);
      }
      this.selectList = [...map.values()];
    },
    cancelAll(selection) {
      this.modelData.forEach((row) => {
        this.selectList.forEach((el, index) => {
          if (el.serialnumber == row.serialnumber) {
            this.selectList.splice(index, 1);
          }
        });
      });
    },
    itemChange() {
      this.personNum = this.selectList.length;
    },
    addJob() {
      this.$refs.JobModal.jobmodal = true;
      this.$refs.JobModal.nullJobSerialnumberList = [...this.selectList];
    },
    jobSave() {},
    dirSearch() {
      this.$refs.DirModalComponent.modalShow = true;
    },
    dirSelect(item) {
      let json = JSON.parse(item);
      this.modalFormItem.dirSupName = json.userName;
      this.modalFormItem.dirSupSerialnumber = json.dirSupSerialnumber;
      this.$set(this.modalFormItem, "dirSupName", json.userName);
      this.levelDisabledState = false;
    },
    dirClear() {
      this.modalFormItem.dirSupSerialnumber = "";
      this.levelDisabledState = true;
    },
    pageSizeChange(val) {
      this.pageInfo.pageSize = val;
      this.getData();
    },
    handleReset() {
      this.modalFormItem = {
        dirSupName: "",
        levelNum: [],
      };
      this.$refs.UserGroupList.selectModalGroupList = [];
      this.$refs.UserGroupList.modalFormItem.userGroupList = [];
      // this.pageInfo.pageNo=1
      // this.getData()
    },
  },
};
</script>

<style lang="less" scoped>
// /deep/.ivu-modal {
//   top:2% !important
// }
/deep/.ivu-modal-fullscreen .ivu-modal-body {
  overflow-y: auto;
  height: 100% !important;
  max-height: 88%;
}
</style>



// WEBPACK FOOTER //
// src/components/process/performanceManagement/PeopleBoardComponents/PDselectPeople.vue